export default __webpack_public_path__ + "static/media/external-link.bec977f6.svg";